/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" label-position="right" label-width="100px" ref="formInlineRef"  :model="formInline" class="user-search">
      <el-form-item label="用户账号：" prop="account">
        <el-input size="small" v-model="formInline.account" placeholder="请输入用户账号"></el-input>
      </el-form-item>
      <el-form-item label="联系手机：" prop="phone">
        <el-input size="small" v-model="formInline.phone" placeholder="请输入联系手机"></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱：" prop="mail">
        <el-input size="small" v-model="formInline.mail" placeholder="请输入联系邮箱"></el-input>
      </el-form-item>
      <el-form-item label="创建时间：" prop="datePicker">
        <el-date-picker style="height: 33px;width: 300px;"
                        v-model="times"
                        type="daterange"
                        @change="dataPicker"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="tableList">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
              :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center"  prop="account" label="用户账号" ></el-table-column>
      <el-table-column align="center"  prop="userName" label="用户名称" ></el-table-column>
      <el-table-column align="center"  prop="roleName" label="角色名称" ></el-table-column>
      <el-table-column align="center"  prop="phone" label="联系手机" ></el-table-column>
      <el-table-column align="center"  prop="mail" label="邮箱" ></el-table-column>
      <el-table-column align="center"  prop="loginNum" label="登录次数" width="70px" ></el-table-column>
      <el-table-column align="center"  prop="status" label="使用状态"  width="170px">
        <template slot-scope="scope">
          <el-switch
            :disabled="scope.row.account=='admin'"
            v-model="scope.row.status"
            active-text="使用中"
            inactive-text="禁用"
            :active-value="1"
            :inactive-value="0"
            @change="turn(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center"  prop="createTime" label="创建时间" width="150px" >
        <template slot-scope="scope">
          <div>{{scope.row.createTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center"  prop="loginTime" label="最后登录时间" width="150px" >
        <template slot-scope="scope">
          <div>{{scope.row.loginTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center"  width="250px" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="resetpwd(scope.$index, scope.row)" v-if="scope.row.account!='admin'|| (account=='admin' && scope.row.account=='admin')">修改密码</el-button>
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.account!='admin'" >编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteData(scope.$index, scope.row)" v-if="scope.row.account!='admin'" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @open="qrySysRoleList" @click='closeDialog("edit")' :close-on-click-modal="false">
      <el-form label-width="120px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="登录用户账号" prop="account">
          <el-input size="small" v-model="editForm.account" auto-complete="off" placeholder="请输入登录用户账号"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称" prop="userName">
          <el-input size="small" v-model="editForm.userName" auto-complete="off" placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input size="small" v-model="editForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="用户头像" prop="userImg">
          <el-upload
            class="avatar-uploader"
            :action="this.host+'/fileUpload/ossBatch'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="editForm.userImg" :src="editForm.userImg" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">请用户上传头像</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户联系手机" prop="phone">
          <el-input size="small" v-model="editForm.phone" placeholder="请输入用户联系手机"></el-input>
        </el-form-item>
        <el-form-item label="联系电子邮箱" prop="mail">
          <el-input size="small" v-model="editForm.mail" placeholder="请输入联系电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select size="small" v-model="editForm.roleId" placeholder="请选择" class="userRole">
            <el-option v-for="(type,index) in roleListData" :label="type.roleName" :value="type.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户身份描述" prop="remark">
          <el-input size="small" v-model="editForm.remark" placeholder="请输入用户身份描述"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog title="修改密码" :visible.sync="editPwVisible" width="30%" @click='closeDialog("editPw")'>
      <el-form label-width="80px" ref="editPw" :model="editPwForm" >
        <el-form-item label="账号" prop="userName">
          <el-input size="small" v-model="editPwForm.account" disabled auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="userName">
          <el-input size="small" v-model="editPwForm.userName" disabled auto-complete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input size="small" v-model="editPwForm.password"  placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="tpassword">
          <el-input size="small" v-model="editPwForm.tpassword" placeholder="请输入确认密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" :disabled="isDisabled" @click="submitForm('editPw')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {qrySysUserist,qrySysRoleList,addSysUser,upSysUser,delSysUser} from '../../api/sysApi'
import Pagination from '../../components/Pagination'
import {timestampToTime,parseTime} from "../../utils/util";
export default {
  data() {
    return {
      isDisabled: false,
      loading: false, //是显示加载
      title: '添加用户',
      editFormVisible: false, //控制编辑页面显示与隐藏
      editPwVisible:false,
      times:'',
      account:'',
      // 编辑与添加
      editForm: {
        id: '',
        account: '',
        userName: '',
        roleId: '',
        phone: '',
        userImg:'',
        mail:'',
        remark:"",
        password:''
      },
      editPwForm:{
        id: '',
        account: '',
        userName: '',
        password: '',
        tpassword: ''
      },
      roleListData:[],
      // rules表单验证
      rules: {
        account: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        roleId: [
          { required: true, message: '请选择角色', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        userImg: [
          { required: true, message: '请上传用户图像', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }, { pattern:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的手机号码' }
        ],
        mail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }, { pattern:'^\\s*\\w+(?:\\.{0,1}[\\w-]+)*@[a-zA-Z0-9]+(?:[-.][a-zA-Z0-9]+)*\\.[a-zA-Z]+\\s*$', message: '请输入正确的邮箱' }
        ],
      },
      // 请求数据参数
      formInline: {
        page: 1,
        pageSize: 10,
        phone: '',
        mail:'',
        account:'',
        beginTime: "", // 开始时间
        endTime: "" // 结束时间
      },
      //用户数据
      listData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.account=JSON.parse(localStorage.getItem("userdata")).account;
    this.tableList(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    qrySysRoleList(){
      qrySysRoleList({pageSize:100})
        .then(res => {
          this.loading = false
          if (res.code!=1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.roleListData = res.data.list;
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('系统异常，请稍后再试！')
        })
    },
    /**
     * @name: dataPicker
     * @Author: TJH
     * @msg: 时间选择器
     * @Date: 2021-02-25 14:47:12
     * @param value：[开始时间,结束时间]
     * @return {*}
     */
    dataPicker(value) {
      if (value != null) {
        console.log(value);
        this.formInline.beginTime = parseTime(
          value[0],
          "{y}-{m}-{d}"
        );
        this.formInline.endTime = parseTime(value[1], "{y}-{m}-{d}");
      } else {
        this.formInline.beginTime = "";
        this.formInline.endTime = "";
      }
    },
    // 获取数据方法
    tableList(parameter) {
      this.loading = true;
      qrySysUserist(parameter)
        .then(res => {
          this.loading = false
          if (res.code!=1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.list;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.data.total;
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('系统异常，请稍后再试！')
        })
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.tableList(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改用户'
        this.editForm.id = row.id
        this.editForm.account = row.account
        this.editForm.userName = row.userName
        this.editForm.phone = row.phone
        this.editForm.roleId = row.roleId
        this.editForm.emit=row.emit
        this.editForm.userImg=row.userImg
        this.editForm.remark=row.remark
        this.editForm.mail=row.mail
        this.editForm.password=row.password
      } else {
        this.title = '添加用户'
        this.editForm.id = ''
        this.editForm.userName = '';
        this.editForm.account = '';
        this.editForm.roleId = '';
        this.editForm.phone = '';
        this.editForm.emit='';
        this.editForm.userImg='';
        this.editForm.remark='';
        this.editForm.mail='';
        this.editForm.password='';
      }
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!='' || this.editPwForm.id!=''){
            if(this.editPwForm.password!=this.editPwForm.tpassword){
              this.$message.error('密码不一致！')
              this.isDisabled = false;
              return;
            }
            upSysUser(editData=='editPw'?this.editPwForm:this.editForm).then(res =>{
              this.editFormVisible = false
              this.editPwVisible = false;
              this.loading = false
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            })
          }else{
            addSysUser(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code==1) {
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.tableList(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }

          // 请求方法

        } else {
          this.isDisabled = false;
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      this.editFormVisible = false;
      this.editPwVisible = false;
    },
    // 删除用户
    deleteData(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delSysUser({id:row.id})
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已更新!'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
    // 重置密码
    resetpwd(index, row) {
      this.editPwVisible = true;
      this.editPwForm.id= row.id;
      this.editPwForm.account = row.account;
      this.editPwForm.userName = row.userName;
    },
    handleAvatarSuccess(res, file) {
      this.editForm.userImg = res.data;
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    turn(row) {
      var data={
        id:row.id,
        status:row.status
      }
      upSysUser(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
/deep/ .el-input__prefix,
/deep/ .el-input__icon {
  line-height: 25px;
}
/deep/ .el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 23px;
  width: 5%;
  color: #303133;
}
</style>




// WEBPACK FOOTER //
// src/views/system/user.vue